import { boolean, object } from "superstruct";

export const GrowaveStorefrontValuesAccountUISchema = object({
    canUseAccountUI: boolean(),
});
